export enum DashboardType {
    WorkComp = 'wc-dashboard',
    Referral = 'ref-dashboard',
    Admin = 'admin-dashboard'
}
